<script lang="ts">
import FicheEtablissementList from '@/generated/fiches/FicheEtablissementList.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: FicheEtablissementList,
    data() {
      return {
        cardView: true
      }
    },
    methods: {
        isDisplayed(value: string): boolean {
            return true;
        }
    }
})

</script>
